
const ImgOk = () => (
    <img src={require('./Ok.svg').default} alt='imagen' />
);

const ImgError = () => (
    <img  src={require('./Error.svg').default} alt='imagen' />
);

export { ImgOk, ImgError }